import { Badge as AntBadge } from "antd";
import type { BadgeProps } from "antd";
import type React from "react";
import styled from "styled-components";

type Props = {
  backgroundColor?: string;
  children?: React.ReactNode;
} & BadgeProps;

const styledBadgeAttrs = (props: Props) => ({
  backgroundColor: props.backgroundColor,
});

const StyledBadge = styled(AntBadge).attrs(styledBadgeAttrs)`
  > sup {
    background: ${(props) => props.backgroundColor};
  }
`;

const Badge = (props: Props) => {
  return <StyledBadge {...props}>{props.children}</StyledBadge>;
};

export default Badge;
